module.exports = __webpack_public_path__ + "static/media/login-background.52d81745.jpg";